import type { ServiceIdentifier } from 'inversify'

import type { AccountUsecase, MessageUsecase } from '@/apis/usecases'

import type {
  AccountRepository,
  MessageRepository,
} from '@/apis/usecases/dataAccesses'

import type {
  APIConfig,
  BigbrotherClient,
  CinnamonClient,
  CinnamonWebSocketFactory,
  DerekClient,
  HotelClient,
  Logger,
} from '@/apis/infrastructures'

const createLabel = <T>(key: string): ServiceIdentifier<T> => Symbol(key)

const TYPES = {
  // usecase
  AccountUsecase: createLabel<AccountUsecase>('AccountUsecase'),
  MessageUsecase: createLabel<MessageUsecase>('MessageUsecase'),

  // repository
  AccountRepository: createLabel<AccountRepository>('AccountRepository'),
  MessageRepository: createLabel<MessageRepository>('MessageRepository'),

  // infra
  CinnamonClient: createLabel<CinnamonClient>('CinnamonClient'),
  CinnamonWebSocketFactory: createLabel<CinnamonWebSocketFactory>(
    'CinnamonWebSocketFactory'
  ),
  DerekClient: createLabel<DerekClient>('DerekClient'),
  BigbrotherClient: createLabel<BigbrotherClient>('BigbrotherClient'),
  HotelClient: createLabel<HotelClient>('HotelClient'),
  Logger: createLabel<Logger>('Logger'),

  // config
  APIConfig: createLabel<APIConfig>('APIConfig'),
} as const

export { TYPES }
